"use strict";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
var commaSeparation = function commaSeparation(list) {
  if (list == null || list.size === 0) return '';
  var output = [list.slice(0, -1).join(', '), list.slice(-1)[0]].join(list.length < 2 ? '' : ' og ');
  output = output.toLowerCase();
  return output.charAt(0).toUpperCase() + output.slice(1);
};
var capitalizeFirst = function capitalizeFirst(s) {
  if (typeof s !== 'string') return '';
  return s.charAt(0).toUpperCase() + s.slice(1);
};
var isEmpty = function isEmpty(s) {
  return !s || s.length === 0 || s === [];
};
var formattedPropertyTypes = function formattedPropertyTypes(propertyTypes) {
  if (propertyTypes == null || propertyTypes.length === 0) {
    return '';
  }
  if (propertyTypes.length === 1) {
    return propertyTypes[0];
  }
  var mutatedPropertyTypes = _toConsumableArray(propertyTypes);
  var last = mutatedPropertyTypes.pop();
  return "".concat(mutatedPropertyTypes.join(', '), " og ").concat(last);
};
var toMinMaxString = function toMinMaxString(array) {
  if (array && array.length > 0) {
    var min = Math.min.apply(Math, _toConsumableArray(array));
    var max = Math.max.apply(Math, _toConsumableArray(array));
    if (max === min) {
      return max;
    }
    return "".concat(min, " - ").concat(max);
  }
  return null;
};
var removeWhitespace = function removeWhitespace(shouldRemove, string) {
  return shouldRemove ? string.replace(/\s/g, '') : string;
};
var sanitizeString = function sanitizeString(str) {
  return str.replace(/<[^>]*>/g, '').replace(/([<>"'\\/])/g, '');
};
var replaceAll = function replaceAll(str, replace, replacement) {
  if (!str || !replacement) return str;
  return str.split(replace).join(replacement);
};
var displayEnergyLabel = function displayEnergyLabel(_char, color) {
  if (_char && color) {
    return "".concat(_char, " - ").concat(color);
  }
  if (_char) {
    return _char;
  }
  if (color) {
    return color;
  }
  return false;
};
var formatPhoneNumber = function formatPhoneNumber(number) {
  if (number === null) {
    return null;
  }
  // for numbers of the 0047 xxx xx xxx format
  if (number.length === 12) {
    return number.replace(/(\d{4})(\d{3})(\d{2})(\d{3})/, '$1 $2 $3 $4');
  }
  // for numbers of the +47 xxx xx xxx format
  if (number.length === 11) {
    return number.replace(/(\+\d{2})(\d{3})(\d{2})(\d{3})/, '$1 $2 $3 $4');
  }
  return number.replace(/(\d{3})(\d{2})(\d{3})/, '$1 $2 $3');
};

// helper to display P-ROM as default, or BRA if it does not exist
var displayPROMorBRA = function displayPROMorBRA(primaryRoomArea, usableArea) {
  if (primaryRoomArea && primaryRoomArea !== 0) {
    return "".concat(primaryRoomArea, " m\xB2");
  }
  if (usableArea && usableArea !== 0) {
    return "".concat(usableArea, " m\xB2 (BRA)");
  }
  return '-';
};
module.exports = {
  commaSeparation: commaSeparation,
  capitalizeFirst: capitalizeFirst,
  isEmpty: isEmpty,
  formattedPropertyTypes: formattedPropertyTypes,
  removeWhitespace: removeWhitespace,
  sanitizeString: sanitizeString,
  toMinMaxString: toMinMaxString,
  replaceAll: replaceAll,
  displayEnergyLabel: displayEnergyLabel,
  formatPhoneNumber: formatPhoneNumber,
  displayPROMorBRA: displayPROMorBRA
};